// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--JXKLa","title-wrapper":"_9e1425b4d3--title-wrapper--MqZMR","button-wrapper":"_9e1425b4d3--button-wrapper--yEKoK"};